<template>
  <v-content>
    <v-container>
      <v-card max-width="85%" class="mx-auto">
        <v-card-title>
          <h3 class="mx-auto">
            Map Pincodes
          </h3>
        </v-card-title>
        <v-card-text>
          <v-alert transition="scroll-y-transition" prominent type="error" :value="error.status">
            {{error.message}}
          </v-alert>
          <v-alert transition="scroll-y-transition" prominent type="success" :value="success.status">
            {{success.message}}
          </v-alert>
          <v-form class="text-center" ref="mapPincodeForm" @submit.prevent="mapPincode">
            <v-text-field
              label="Pincode"
              color="accent"
              v-model="pincode"
              :rules="pincodeRules"
            ></v-text-field>
            <v-select
              label="Select ASO"
              v-model="selectedAso"
              :items="asos"
              item-text="name"
              :return-object="true"
              :rules="asoRules"
            ></v-select>
            <v-btn type="submit" :loading="processing" color="accent">Map Pincode</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
export default {
  data() {
    return {
      asos: [],
      pincode: null,
      selectedAso: null,
      processing: false,
      success: {
        status: false,
        message: '',
      },
      error: {
        status: false,
        message: '',
      },
    };
  },
  methods: {
    async mapPincode() {
      // here we must map pincode
      this.success.status = false;
      this.error.status = false;
      if (this.$refs.mapPincodeForm.validate()) {
        this.processing = true;
        const { selectedAso } = this;
        try {
          await this.firebase.firestore().collection('pincodes').doc(this.pincode).set({
            asoId: selectedAso.id,
            asoName: selectedAso.name,
          });
          this.success.status = true;
          this.success.message = 'Pincode mapped successfully';
          this.processing = false;
          this.formReset();
          this.$refs.mapPincodeForm.resetValidation();
        } catch (error) {
          console.log(error);
          this.error.status = true;
          this.error.message = 'Unknown Error! Please try again';
          this.processing = false;
        }
      }
    },
    formReset() {
      this.pincode = null;
      this.selectedAso = null;
    },
    async getAsos() {
      // do this
      const { asos } = this;
      try {
        const asosQuery = await this.firebase.firestore().collection('asos').get();
        asosQuery.forEach(async (item) => {
          asos.push({ uid: item.id, ...await item.data() });
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    pincodeRules() {
      return [
        (v) => !!v || 'Pincode is required',
        (v) => (!isNaN(v)) || 'Pincode should be a number',
        (v) => (parseInt(v, 10) > 0) || 'Pincode can not be a negative or 0 value',
        (v) => (v !== null && v.length === 6) || 'Pincode should be 6 numbers',
      ];
    },
    asoRules() {
      return [
        (v) => !!v || 'ASO is required',
      ];
    },
  },
  beforeMount() {
    this.getAsos();
  },
};
</script>
